import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { filter, Observable, take } from 'rxjs';
import { CareerPathway } from '@cpd-app/generated';
import { PathwayFacade } from '@cpd-app/state/pathway';

export const pathwayResolver: ResolveFn<CareerPathway> = (
  route: ActivatedRouteSnapshot
): Observable<CareerPathway> => {
  const pathwayFacade = inject(PathwayFacade);
  const pathwayId: string = route.params['pathwayId'];

  pathwayFacade.clearPathway();
  pathwayFacade.getPathway(pathwayId);

  return pathwayFacade.pathway$.pipe(filter((pathway) => !!pathway), take(1));
};
